import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../i18n';
import { Globe, ChevronDown } from 'lucide-react';

const LanguageSwitcher = ({ variant = 'header', onSelect }) => {
  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const current = SUPPORTED_LANGUAGES.find((l) => l.code === i18n.language) || SUPPORTED_LANGUAGES[0];

  const choose = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
    if (onSelect) onSelect(code);
  };

  // Mobile variant: flache horizontale Liste statt Dropdown
  if (variant === 'mobile') {
    return (
      <div
        className="flex flex-wrap gap-2"
        data-testid="language-switcher-mobile"
      >
        {SUPPORTED_LANGUAGES.map((lng) => {
          const active = i18n.language === lng.code;
          return (
            <button
              key={lng.code}
              type="button"
              onClick={() => choose(lng.code)}
              data-testid={`language-option-${lng.code}`}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-xs tracking-wider border transition-colors ${
                active
                  ? 'bg-[#b8893d] text-white border-[#b8893d]'
                  : 'bg-white text-[#1B3A5C] border-[#1B3A5C]/20 hover:border-[#b8893d]'
              }`}
            >
              <span className="text-base leading-none">{lng.flag}</span>
              <span>{lng.code.toUpperCase()}</span>
            </button>
          );
        })}
      </div>
    );
  }

  const triggerCls =
    variant === 'header'
      ? 'inline-flex items-center gap-1.5 text-[#1B3A5C] hover:text-[#b8893d] text-xs tracking-wider transition-colors'
      : 'inline-flex items-center gap-1.5 text-white/70 hover:text-[#b8893d] text-xs tracking-wider transition-colors';

  return (
    <div className="relative" data-testid="language-switcher">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        className={triggerCls}
        aria-label={t('common.language', 'Sprache')}
        data-testid="language-switcher-toggle"
      >
        <Globe className="w-4 h-4" />
        <span className="hidden sm:inline">{current.flag} {current.code.toUpperCase()}</span>
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div
          className="absolute right-0 top-full mt-2 bg-white border border-gray-200 shadow-lg rounded-sm py-1 min-w-[160px] z-50"
          data-testid="language-switcher-menu"
        >
          {SUPPORTED_LANGUAGES.map((lng) => (
            <button
              key={lng.code}
              type="button"
              onMouseDown={(e) => { e.preventDefault(); choose(lng.code); }}
              data-testid={`language-option-${lng.code}`}
              className={`w-full text-left px-4 py-2 text-sm hover:bg-[#fbf7f0] flex items-center gap-2.5 transition-colors ${
                i18n.language === lng.code ? 'text-[#b8893d] font-medium bg-[#fbf7f0]' : 'text-[#1B3A5C]'
              }`}
            >
              <span className="text-base leading-none">{lng.flag}</span>
              <span>{lng.label}</span>
              {i18n.language === lng.code && <span className="ml-auto text-[#b8893d]">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
